import { useEffect } from 'react';
import AOS from 'aos';

import Navbar from '../components/Navbar';
import HeroSection from '../components/HeroSection';
import LiquidityStats from '../components/LiquidityStats';
import StrategiesSection from '../components/StrategiesSection';
import CalculatorSection from '../components/CalculatorSection';
import HowItWorksSection from '../components/HowItWorksSection';
import FeaturesSection from '../components/FeaturesSection';
import SecuritySection from '../components/SecuritySection';
import PartnerProgramSection from '../components/PartnerProgramSection';
import SwapFeed from '../components/SwapFeed';
import FaqSection from '../components/FaqSection';
import LastChanceCTA from '../components/LastChanceCTA';
import StickyDepositBar from '../components/StickyDepositBar';
import Footer from '../components/Footer';

const Landing = () => {
  useEffect(() => {
    AOS.init({
      duration: 700,
      easing: 'ease-out-cubic',
      once: true,
      offset: 80,
    });
  }, []);

  return (
    <div className="app">
      <Navbar />
      <main>
        <HeroSection />
        <LiquidityStats />
        <StrategiesSection />
        <CalculatorSection />
        <HowItWorksSection />
        <FeaturesSection />
        <SecuritySection />
        <PartnerProgramSection />
        <SwapFeed />
        <FaqSection />
        <LastChanceCTA />
      </main>
      <Footer />
      <StickyDepositBar />
    </div>
  );
};

export default Landing;
